module.exports = __webpack_public_path__ + "static/media/add canteen item.ea1f9cc2.svg";